import React from "react"

export const NotFound = () => <div>Page not found</div>
